import styled from "styled-components";

export const HeadersContainer = styled.div<{
  gridTemplateColumns: string | undefined;
}>`
  display: grid;
  grid-auto-flow: column;
  overflow: hidden;
  margin-left: 30px;
  grid-column-gap: 1.1rem;
  grid-template-columns: ${({ gridTemplateColumns }) =>
    gridTemplateColumns ?? "repeat(auto-fit, minmax(7rem, 1fr))"};

  /* If the screen is less than 1280px in width,reduce gap width and enable scroll for overflow */
  @media (max-width: 1280px) {
    grid-column-gap: 0.05rem;
    grid-template-columns: ${({ gridTemplateColumns }) =>
      gridTemplateColumns ?? "repeat(auto-fit, minmax(5.6rem, 1fr))"};
  }
`;

export const TableHeader = styled.p`
  font-weight: 700;
  font-size: 18px;
  margin: 0;
  @media (max-width: 1280px) {
    font-size: 16px;
  }
`;

export const ContainerDisableRounded = styled.div<{ noRounded: boolean }>`
  div {
    border-radius: ${(props) =>
      props.noRounded ? "0px !important" : "6px !important"};
  }
`;
